var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupTherapySessions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XwAK5E"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.81,13.7c.31-.2.56-.47.86-.67,2.32-1.56,5.45-1.33,7.42.67h.09c.75-1.12,2.29-1.78,3.62-1.71,2.16.12,3.98,1.92,4.15,4.11.03.41.06,1.7-.01,2.05s-.61.43-.73.15c-.13-.32,0-1.57-.04-2.02-.25-3.44-4.44-4.75-6.46-2-.01.13.34.55.43.72.44.8.76,1.76.83,2.69.04.66.09,2.24,0,2.85-.05.35-.47.51-.7.26-.16-.17-.04-2.49-.07-2.94-.3-4.76-6.03-6.86-9.13-3.25-1.54,1.8-1.27,3.8-1.3,6.04-.07.37-.7.37-.76-.17-.08-.68-.05-2.03,0-2.74.08-1.24.55-2.41,1.26-3.41.02-.15-.41-.55-.54-.67-2.29-1.99-5.7-.39-5.92,2.62-.03.36.08,1.92-.08,2.08-.23.24-.65.09-.7-.26-.06-.42-.04-1.49,0-1.94.23-3.25,3.71-5.18,6.52-3.59.46.26,1,.66,1.26,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.87,3.08c3.12-.1,5.17,3.39,3.57,6.12-1.46,2.48-4.98,2.68-6.66.33-1.87-2.62-.1-6.35,3.09-6.45ZM11.45,3.93c-1.18.16-2.27,1.24-2.54,2.4-.65,2.8,2.22,5.03,4.69,3.61,3-1.73,1.49-6.51-2.15-6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.47,5.51c3.42-.13,3.94,4.97.68,5.62-3.95.79-4.61-5.48-.68-5.62ZM19.17,6.36c-1.1.16-1.79,1.43-1.52,2.49.46,1.85,3.02,2.07,3.76.33.68-1.57-.62-3.06-2.24-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.33,5.51c3.39-.1,3.93,4.92.68,5.62-3.94.85-4.65-5.51-.68-5.62ZM4.03,6.36c-2.1.31-2.1,3.67,0,3.98,3.15.47,3.16-4.45,0-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.39,17.67c.34-.02.42.28.44.56.05.51.06,1.76,0,2.25-.08.61-.77.63-.83-.11-.05-.51-.06-1.76,0-2.25.03-.23.14-.43.39-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.57,17.67c.37-.02.42.32.44.62.04.51.06,1.69,0,2.19-.08.61-.77.63-.83-.11-.05-.51-.06-1.76,0-2.25.03-.23.14-.43.39-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.73,18.37c-.07-.07-.07-.22-.08-.32-.03-.34-.05-1.4,0-1.7.07-.39.7-.39.77.06.05.3.05,1.4,0,1.69-.05.35-.47.51-.7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.28,18.37c-.22.23-.65.09-.7-.26-.05-.3-.05-1.4,0-1.69.07-.45.7-.45.77-.06.06.3.03,1.36,0,1.7,0,.09-.01.25-.08.32Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupTherapySessions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group-therapy-sessions.650b6a6e67883bb3746c42ffa0f96459.svg";